import useSeoProject from '@/hooks/useSeoProject';
import { SerpSummary, SerpAnalysisResult, LivePositionResult } from '@/services/seoAi';
import { SeoTask } from '@/types/api/seo';
import { useOpportunityAnalysis } from '@/hooks/seo/useOpportunityAnalysis';
import { useTaskCreation } from '@/hooks/seo/useTaskCreation';
import KeywordOpportunitiesComponent from './KeywordOpportunities.component';

type Props = {
  projectId: string;
  keywordId: string;
  keyword: string;
  position: number | null;
  ctr: number | null;
  clicks: number | null;
  impressions: number | null;
  days: number;
  rankingPages: Array<{ page: string; position: number; clicks: number; impressions: number; ctr: number }>;
  serpSummary: SerpSummary | null;
  positionHistory: Array<{ date: string; position: number }>;
  rankingPageUrl?: string;
  sitePages?: Array<{ page: string; keyword?: string }>;
  serpAnalysis?: SerpAnalysisResult | null;
  livePosition?: LivePositionResult | null;
  existingTasks?: SeoTask[];
  onTaskCreated?: () => void;
};

const KeywordOpportunitiesContainer = function (props: Props): JSX.Element {
  const { projectId, keywordId, keyword, position, ctr, clicks, impressions, days, rankingPages, serpSummary, positionHistory, rankingPageUrl, sitePages, serpAnalysis, livePosition, existingTasks: existingTasksProp, onTaskCreated } = props;
  const { project } = useSeoProject();
  const wpConnected = !!(project?.wpConnectedAt && project?.wpSiteUrl);

  const {
    opportunities, setOpportunities, isLoading, isAnalyzing,
    handleAnalyze, handleStatusChange, handleGetFixGuidance,
    handleGetSuggestions, handleApplyToWordPress, handleGenerateStepSuggestions,
  } = useOpportunityAnalysis({
    keyword, position, ctr, clicks, impressions, days, rankingPages,
    serpSummary, serpAnalysis, positionHistory, rankingPageUrl, sitePages,
    livePosition, project, projectId, keywordId,
  });

  const { handleAddTask } = useTaskCreation(projectId, keywordId, opportunities, setOpportunities, onTaskCreated);

  return (
    <KeywordOpportunitiesComponent
      opportunities={opportunities}
      isLoading={isLoading}
      isAnalyzing={isAnalyzing}
      onAnalyze={handleAnalyze}
      onStatusChange={handleStatusChange}
      onGetFixGuidance={handleGetFixGuidance}
      onGetSuggestions={handleGetSuggestions}
      onApplyToWordPress={handleApplyToWordPress}
      wpConnected={wpConnected}
      rankingPageUrl={rankingPageUrl ?? null}
      currentMetrics={{ position, ctr, clicks, impressions }}
      livePosition={livePosition?.livePosition ?? null}
      onGenerateStepSuggestions={handleGenerateStepSuggestions}
      onAddTask={handleAddTask}
      existingTasks={existingTasksProp ?? []}
    />
  );
};

export default KeywordOpportunitiesContainer;
